import '@angular/localize/init';
import { bootstrapApplication } from '@angular/platform-browser';
import { applicationConfig } from './app/application.config';
import { ApplicationComponent } from './app/application.component';
import { environment } from './environments/environment';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    // Check for specific conflicts that need cleanup
    const hasConflicts = registrations.some(
      (reg) =>
        reg.scope.includes('firebase-cloud-messaging-push-scope') ||
        (reg.scope.includes('firebase-messaging-sw.js') &&
          reg.scope !== window.location.origin + '/'),
    );

    if (hasConflicts) {
      // Clean up only problematic service workers
      registrations.forEach((reg) => {
        if (
          reg.scope.includes('firebase-cloud-messaging-push-scope') ||
          (reg.scope.includes('firebase-messaging-sw.js') &&
            reg.scope !== window.location.origin + '/')
        ) {
          reg.unregister();
        }
      });

      // Wait for cleanup, then register
      setTimeout(() => {
        registerServiceWorker();
      }, 500);
    } else {
      registerServiceWorker();
    }
  });
}

function firebaseMessagingWorkerUrl(): string {
  const config = environment.firebaseConfig;
  if (!config?.apiKey || !config?.projectId) {
    return '/firebase-messaging-sw.js';
  }
  return `/firebase-messaging-sw.js?config=${encodeURIComponent(JSON.stringify(config))}`;
}

function registerServiceWorker() {
  navigator.serviceWorker
    .register(firebaseMessagingWorkerUrl(), {
      scope: '/',
    })
    .catch((error) => console.error('Error al registrar el Service Worker:', error));
}
bootstrapApplication(ApplicationComponent, applicationConfig).catch((err) => console.error(err));
